import React from "react"
import {
    Box,
    componentStyles,
    HeadingXSmall,
    Image,
    LoadingOrErrorContainer,
    useIsDarkMode,
} from "@mallardbay/lib-react-components"

import Deer from "~images/lodging/deer.svg"
import ListingsCollection from "~components/shared/collections/listings-collection"
import { TYPES } from "~components/shared/collections/generic-collection"
import COPY from "~config/copy-constants"
import { useCurrentOutfitter } from "~components/providers/current-outfitter-provider"
import { TEST_IDS } from "~config/test-ids"
import useOutfitterListings from "~utils/use-outfitter-listings"

const ICON_WIDTH = "52px"

export default function OutfitterListings() {
    const styles = useStyles()
    const { listings, hasListings, isLoading, error } = usePublishedListings()
    const shouldRenderCollection = hasListings || isLoading

    return (
        <LoadingOrErrorContainer
            testId={TEST_IDS.OUTFITTER_LISTINGS}
            error={error}
            shouldRenderChildren
        >
            {shouldRenderCollection && (
                <ListingsCollection
                    listings={listings}
                    label={COPY.LISTINGS}
                    type={TYPES.SLIDER}
                    isLoading={isLoading}
                    shouldLinkToOutfitter={false}
                />
            )}
            {!shouldRenderCollection && (
                <Box style={styles.container}>
                    <Image src={Deer} style={styles.icon} />

                    <HeadingXSmall style={styles.emptyHeading}>
                        {COPY.OUTFITTER_HAS_NO_LISTINGS}
                    </HeadingXSmall>
                </Box>
            )}
        </LoadingOrErrorContainer>
    )
}

function usePublishedListings() {
    const { currentOutfitter } = useCurrentOutfitter()
    const { listings, isLoading, error } = useOutfitterListings({
        outfitterId: currentOutfitter.id,
    })
    const publishedListings = listings.filter((listing) => listing.published)
    const hasListings = publishedListings.length > 0

    return { listings: publishedListings, hasListings, isLoading, error }
}

function useStyles() {
    const isDarkMode = useIsDarkMode()

    return componentStyles({
        container: {
            paddingTop: "4rem",
            textAlign: "center",
        },
        emptyHeading: {
            marginTop: "12px",
        },
        icon: {
            marginRight: 0,
            filter: isDarkMode ? "invert(100%)" : "",
            width: ICON_WIDTH,
            height: ICON_WIDTH,
        },
    })
}
